<template>
  <div class="footprint-wrapper_single">
    <form @submit.prevent="handleFormSubmit" v-if="!preloaderVisibility">
      <div class="container">

        <div class="row">
          <div
              v-for="(singleInput, index) in Object.values(formInputs)"
              :key="index"
              :class="Object.values(formInputs).length === 3 ? 'col-4' : 'col-6'"
          >
            <vueSelect
                :disabled="editMode || singleInput.values.length === 1"
                :placeholder="codeKeys[formData.group][index]"
                :searchable="true"
                :options="singleInput.values"
                v-model="singleInput.selectValue"
                class="select"
            >
              <template #search="{attributes, events}">
                <input
                    class="vs__search"
                    :required="!singleInput.selectValue"
                    v-bind="attributes"
                    v-on="events"
                />
              </template>
            </vueSelect>
          </div>
        </div>

        <div class="title-row row">
          <div class="col-12">
            <h2>Interpretation</h2>
            <label>
              <textarea
                  minlength="10"
                  required="required"
                  v-model="formData.data"
              />
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col-6 buttons-wrapper">
            <button v-if="editMode" @click.prevent="handleModalWindowVisibility">Delete</button>
          </div>
          <div class="col-6 align-end buttons-wrapper">
            <button @click.prevent="handleCancelButton">Cancel</button>
            <input type="submit" value="Save">
          </div>
        </div>
      </div>
    </form>
    <PreloaderComponent
        v-if="preloaderVisibility"
    />
    <ModalWindowComponent
        v-if="modalVisibility"
    >
      <h2 class="modal-title">Confirm Deletion</h2>
      <p class="modal-text">Are you sure you want to delete this footprint interpretation?</p>
      <div class="modal-buttons">
        <a class="btn" @click.prevent="handleModalWindowClose">Close</a>
        <a class="btn" @click.prevent="handleFootprintDelete">Yes, Delete</a>
      </div>
    </ModalWindowComponent>
  </div>
</template>

<script>
import vueSelect from 'vue-select'
import SolFileAPIInstance from '@/api'
import PreloaderComponent from '@/components/common/PreloaderComponent'
import ModalWindowComponent from '@/components/common/ModalWindowComponent'

import codeKeys from './codeKeys'

const mockTransferData = {
  code_key: '',
  star_sign: '',
  wos: ''
}

export default {
  props: {
    editMode: {
      required: true,
      type: Boolean
    },
    editData: {
      required: false
    }
  },
  components: {
    vueSelect,
    PreloaderComponent,
    ModalWindowComponent
  },
  data() {
    return {
      formData: {
        group: '',
        data: ''
      },
      formInputs: {},
      codeKeys: {...codeKeys},
      preloaderVisibility: false,
      modalVisibility: false
    }
  },
  name: "FootprintTableSingle",
  methods: {

    async handleFormSubmit() {
      const dataToTransfer = Object.entries({...this.formInputs}).reduce((acc, item) => {
        const [label, value] = item
        acc[label] = value.selectValue
        return acc
      }, {})
      const result = {
        ...mockTransferData,
        ...dataToTransfer,
        data: this.formData.data,
        group: this.formData.group,
      };
      this.editMode
          ? await SolFileAPIInstance.updateFootprintById({
            ...result,
            id: this.$route.params.id
          })
          : await SolFileAPIInstance.addNewFootprint(result)
    },

    handleModalWindowVisibility() {
      this.modalVisibility = true
    },

    handleModalWindowClose() {
      this.modalVisibility = false
    },

    handleFootprintDelete() {
      SolFileAPIInstance.deleteFootprintById(this.$route.params.id)
    },

    handleCancelButton() {
      this.handleRedirect()
    },

    handleRedirect() {
      this.$router.push({path: '/footprint'})
    },

    handleNewItem(data) {
      const {
        group,
        selectValues,
        defaultValues = ['', '', '']
      } = data
      this.formData.group = group
      const transformedData = Object.entries(selectValues).reduce((acc, item, idx) => {
        const [label, values] = item
        acc[label] = {
          selectValue: values.length === 1 ? values[0] : defaultValues[idx]
        }
        acc[label].values = [
          ...values,
        ]
        return acc
      }, {})
      this.formInputs = {...transformedData}
    },

    async handleEditItem() {
      this.preloaderVisibility = true
      const response = await SolFileAPIInstance.getFootprintKeysList()
      const {
        data,
        group,
        ...defaultValues
      } = this.editData
      this.formData.data = data
      if (response.data) {
        this.handleNewItem({
          group,
          selectValues: response.data[group],
          defaultValues: Object.values(defaultValues)
        })
        this.preloaderVisibility = false
      }
    }
  },

  mounted() {
    if (this.$route.params.group) {
      this.handleNewItem(this.$route.params)
    } else if (this.editMode) {
      this.handleEditItem()
    }
  }
}
</script>

<style scoped lang="scss">

.footprint-wrapper {
  &_single {
    padding: 30px;

    col {
      padding: 0 15px;

      &-6 {
        flex: 0 1 50%;
      }
    }

    .row {
      margin-bottom: 15px;

      .buttons-wrapper {
        > * {
          margin: 0 10px;
        }
      }
    }

    textarea {
      min-height: 250px;
    }
  }
}

.modal-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .btn {
    margin: 5px;
  }

}

.select {
  font-size: 11px;
}

h2.modal-title,
p.modal-text {
  text-align: center;
}

</style>